export default {
  form: {
    first_name: {
      label: 'Prénom',
    },
    last_name: {
      label: 'Nom',
    },
    email: {
      label: 'E-mail',
    },
    phone_number: {
      label: 'Numéro de téléphone',
    },
    birthday: {
      label: 'Date de naissance',
    },
    city: {
      label: 'Ville',
    },
  },
  buttons: {
    save: 'Enregistrer',
  },
  toasts: {
    success: 'Profil mis à jour avec succès',
    error: 'Échec de la mise à jour du profil',
  },
};
